import { PayloadAction } from '@reduxjs/toolkit';
import {
    call,
    put,
    select,
    takeLeading,
} from 'redux-saga/effects';

import {
    addOtherIncome,
    addOtherIncomeFulfilled,
    addOtherIncomeRejected,
    deleteOtherIncome,
    deleteOtherIncomeFulfilled,
    deleteOtherIncomeRejected,
    getOtherIncome,
    getOtherIncomeFulfilled,
    getOtherIncomeRejected,
    updateOtherIncome,
    updateOtherIncomeFulfilled,
    updateOtherIncomeRejected,
} from './otherIncomeSlice';
import {
    OtherIncomeApiPayload,
    OtherIncomeDeletePayload,
    OtherIncomeDetailUpsertPayload,
    OtherIncomeEdit,
} from './otherIncomeTypes';
import {
    selectAddDirectIncomeUrl,
    selectAddIndirectIncomeUrl,
    selectDeleteDirectIncomeUrl,
    selectDeleteIndirectIncomeUrl,
    selectGetOtherIncomeUrl,
    selectUpdateDirectIncomeUrl,
    selectUpdateIndirectIncomeUrl,
} from './otherIncomeSelectors';
import { ApiResponse } from '../../utils';
import {
    addOtherIncomeApi,
    deleteOtherIncomeApi,
    fetchOtherIncomeDetailsApi,
    updateOtherIncomeApi,
} from './otherIncomeApi';

function* getOtherIncomeWorkSaga() {
    try {
        const url: string = yield select(selectGetOtherIncomeUrl);
        const res: ApiResponse<OtherIncomeApiPayload> = yield call(fetchOtherIncomeDetailsApi, url);

        yield put(getOtherIncomeFulfilled(res.data));
    } catch (e) {
        yield put(getOtherIncomeRejected());
    }
}

function* getOtherIncomeWatchSaga() {
    yield takeLeading(getOtherIncome.type, getOtherIncomeWorkSaga);
}

function* addOtherIncomeWorkSaga(action: PayloadAction<OtherIncomeDetailUpsertPayload>) {
    const { isDirectIncome } = action.payload;
    const url: string | undefined = isDirectIncome ? yield select(selectAddDirectIncomeUrl) : yield select(selectAddIndirectIncomeUrl);

    if (url) {
        try {

            const { data } = yield call(addOtherIncomeApi, url, action.payload);

            yield put(
                addOtherIncomeFulfilled({
                    ...action.payload,
                    ...data,
                } as OtherIncomeEdit),
            );

        } catch (error) {
            yield put(addOtherIncomeRejected());
        }
    }
}

function* addOtherIncomeWatchSaga() {
    yield takeLeading(addOtherIncome.type, addOtherIncomeWorkSaga);
}

function* updateOtherIncomeWorkSaga(action: PayloadAction<OtherIncomeDetailUpsertPayload>) {
    const { incomeId, isDirectIncome } = action.payload;
    const url: string | undefined = isDirectIncome ? yield select(selectUpdateDirectIncomeUrl) : yield select(selectUpdateIndirectIncomeUrl);

    if (url) {
        try {

            const { data } = yield call(updateOtherIncomeApi, url.replace('{incomeId}', incomeId?.toString() ?? '0'), action.payload);

            yield put(
                updateOtherIncomeFulfilled({
                    ...action.payload,
                    ...data,
                    isEditMode: false,
                } as OtherIncomeEdit),
            );

        } catch (error) {
            yield put(updateOtherIncomeRejected());
        }
    }
}

function* updateOtherIncomeWatchSaga() {
    yield takeLeading(updateOtherIncome.type, updateOtherIncomeWorkSaga);
}

function* deleteOtherIncomeWorkSaga(action: PayloadAction<OtherIncomeDeletePayload>) {
    const { incomeId, isDirectIncome } = action.payload;
    const url: string | undefined = (isDirectIncome)
        ? yield select(selectDeleteDirectIncomeUrl)
        : yield select(selectDeleteIndirectIncomeUrl);

    if (url) {
        try {
            yield call(deleteOtherIncomeApi, url.replace('{incomeId}', `${incomeId}`));

            yield put(deleteOtherIncomeFulfilled(incomeId));
        } catch (e) {
            yield put(deleteOtherIncomeRejected());
        }
    }
    else{
        yield put(deleteOtherIncomeFulfilled(incomeId));
    }
}

function* deleteOtherIncomeWatchSaga() {
    yield takeLeading(deleteOtherIncome.type, deleteOtherIncomeWorkSaga);
}

export const otherIncomeSagas = [
    getOtherIncomeWatchSaga,
    addOtherIncomeWatchSaga,
    updateOtherIncomeWatchSaga,
    deleteOtherIncomeWatchSaga,
];
